import { render } from "./SmsIdentityValidation.vue?vue&type=template&id=b6738efc&scoped=true"
import script from "./SmsIdentityValidation.vue?vue&type=script&lang=js"
export * from "./SmsIdentityValidation.vue?vue&type=script&lang=js"

import "./SmsIdentityValidation.vue?vue&type=style&index=0&id=b6738efc&scoped=true&lang=css"

import exportComponent from "D:\\PROJET WEB\\carpoolear\\carpoolear_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6738efc"]])

export default __exports__